var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
// TODO: naming convention of imports for readibility.
import USLocaleData from '../locales/US';
import UKLocaleData from '../locales/UK';
import JPLocaleData from '../locales/JP';
import EnAULocaleData from '../locales/en-AU';
import EnSGLocaleData from '../locales/en-SG';
import MsMYLocaleData from '../locales/ms-MY';
import EnTHLocaleData from '../locales/en-TH';
import ThTHLocaleData from '../locales/th-TH';
import AdyenUS from '../components/CreditCard/Adyen/CreditCardUS';
import AdyenUK from '../components/CreditCard/Adyen/CreditCardUK';
import AdyenJP from '../components/CreditCard/Adyen/CreditCardJP';
import AdyenEnAU from '../components/CreditCard/Adyen/CreditCardEnAU';
import AdyenEnSG from '../components/CreditCard/Adyen/CreditCardEnSG';
import AdyenMsMY from '../components/CreditCard/Adyen/CreditCardMsMY';
import AdyenEnTH from '../components/CreditCard/Adyen/CreditCardEnTH';
import AdyenThTH from '../components/CreditCard/Adyen/CreditCardThTH';
import BraintreeUS from '../components/CreditCard/Braintree/CreditCardUS';
import BraintreeUK from '../components/CreditCard/Braintree/CreditCardUK';
import BraintreeJP from '../components/CreditCard/Braintree/CreditCardJP';
import BraintreeEnAU from '../components/CreditCard/Braintree/CreditCardEnAU';
import BraintreeEnSG from '../components/CreditCard/Braintree/CreditCardEnSG';
import BraintreeMsMY from '../components/CreditCard/Braintree/CreditCardMsMY';
import BraintreeEnTH from '../components/CreditCard/Braintree/CreditCardEnTH';
import BraintreeThTH from '../components/CreditCard/Braintree/CreditCardThTH';
import USBillingAddress from '../components/BillingAddress/BillingAddressUS';
import UKBillingAddress from '../components/BillingAddress/BillingAddressUK';
import JPBillingAddress from '../components/BillingAddress/BillingAddressJP';
import EnAUBillingAddress from '../components/BillingAddress/BillingAddressEnAU';
import EnSGBillingAddress from '../components/BillingAddress/BillingAddressEnSG';
import MsMYBillingAddress from '../components/BillingAddress/BillingAddressMsMY';
import EnTHBillingAddress from '../components/BillingAddress/BillingAddressEnTH';
import ThTHBillingAddress from '../components/BillingAddress/BillingAddressThTH';
import { Locale, SupportedVendors } from '../common/Constants';
// non-component and vendor-agnostic mappings
var localeDataMappings = (_a = {},
    _a[Locale.US] = USLocaleData,
    _a[Locale.UK] = UKLocaleData,
    _a[Locale.JP] = JPLocaleData,
    _a[Locale.enAU] = EnAULocaleData,
    _a[Locale.enSG] = EnSGLocaleData,
    _a[Locale.msMY] = MsMYLocaleData,
    _a[Locale.enTH] = EnTHLocaleData,
    _a[Locale.thTH] = ThTHLocaleData,
    _a);
var adyenMappings = (_b = {},
    _b[Locale.US] = __assign(__assign({}, USLocaleData), { creditCardComponent: AdyenUS, billingAddressComponent: USBillingAddress }),
    _b[Locale.UK] = __assign(__assign({}, UKLocaleData), { creditCardComponent: AdyenUK, billingAddressComponent: UKBillingAddress }),
    _b[Locale.JP] = __assign(__assign({}, JPLocaleData), { creditCardComponent: AdyenJP, billingAddressComponent: JPBillingAddress }),
    _b[Locale.enAU] = __assign(__assign({}, EnAULocaleData), { creditCardComponent: AdyenEnAU, billingAddressComponent: EnAUBillingAddress }),
    _b[Locale.enSG] = __assign(__assign({}, EnSGLocaleData), { creditCardComponent: AdyenEnSG, billingAddressComponent: EnSGBillingAddress }),
    _b[Locale.msMY] = __assign(__assign({}, MsMYLocaleData), { creditCardComponent: AdyenMsMY, billingAddressComponent: MsMYBillingAddress }),
    _b[Locale.enTH] = __assign(__assign({}, EnTHLocaleData), { creditCardComponent: AdyenEnTH, billingAddressComponent: EnTHBillingAddress }),
    _b[Locale.thTH] = __assign(__assign({}, ThTHLocaleData), { creditCardComponent: AdyenThTH, billingAddressComponent: ThTHBillingAddress }),
    _b);
var braintreeMappings = (_c = {},
    _c[Locale.US] = __assign(__assign({}, USLocaleData), { creditCardComponent: BraintreeUS, billingAddressComponent: USBillingAddress }),
    _c[Locale.UK] = __assign(__assign({}, UKLocaleData), { creditCardComponent: BraintreeUK, billingAddressComponent: UKBillingAddress }),
    _c[Locale.JP] = __assign(__assign({}, JPLocaleData), { creditCardComponent: BraintreeJP, billingAddressComponent: JPBillingAddress }),
    _c[Locale.enAU] = __assign(__assign({}, EnAULocaleData), { creditCardComponent: BraintreeEnAU, billingAddressComponent: EnAUBillingAddress }),
    _c[Locale.enSG] = __assign(__assign({}, EnSGLocaleData), { creditCardComponent: BraintreeEnSG, billingAddressComponent: EnSGBillingAddress }),
    _c[Locale.msMY] = __assign(__assign({}, MsMYLocaleData), { creditCardComponent: BraintreeMsMY, billingAddressComponent: MsMYBillingAddress }),
    _c[Locale.enTH] = __assign(__assign({}, EnTHLocaleData), { creditCardComponent: BraintreeEnTH, billingAddressComponent: EnTHBillingAddress }),
    _c[Locale.thTH] = __assign(__assign({}, ThTHLocaleData), { creditCardComponent: BraintreeThTH, billingAddressComponent: ThTHBillingAddress }),
    _c);
export var getLocaleDetails = function (vendor, locale) {
    var mappings;
    switch (vendor) {
        case SupportedVendors.adyen:
            mappings = adyenMappings;
            break;
        case SupportedVendors.braintree:
            mappings = braintreeMappings;
            break;
    }
    if (!locale) {
        // throw new Error('Locale is not provided');
        return mappings[Locale.US];
    }
    var data = mappings[locale || Locale.US];
    if (!data) {
        throw new Error("Locale ".concat(locale, " is not supported"));
    }
    return data;
};
export var getLocalisedErrorDisplay = function (locale) {
    var data = localeDataMappings[locale] || USLocaleData;
    return data.errorDisplay;
};
